var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBullhornSolid = function SvgBullhornSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11.3333C22 10.5128 21.5503 9.80417 20.8889 9.41945V4.11146C20.8889 3.80764 20.6465 3 19.7778 3C19.5306 3 19.2851 3.08264 19.084 3.24375L16.1316 5.6059C14.9398 6.55858 13.5033 7.16746 12 7.36983V15.2968C13.5033 15.4992 14.9397 16.1081 16.1313 17.0608L19.0837 19.4229C19.2806 19.5805 19.5252 19.6664 19.7774 19.6667C20.6427 19.6667 20.8885 18.8757 20.8885 18.5556V13.2476C21.5503 12.8625 22 12.1538 22 11.3333ZM11 15.223C10.963 15.2225 10.9259 15.2222 10.8889 15.2222H9.91389C9.81701 15.5767 9.76076 15.9476 9.76076 16.3333C9.76076 17.3431 10.0993 18.275 10.6688 19.0222C11.217 19.7417 10.674 20.7778 9.76944 20.7778H7.19028C6.77778 20.7778 6.38438 20.5566 6.20417 20.1854C5.63819 19.0191 5.31667 17.7142 5.31667 16.3333C5.31667 15.9563 5.3441 15.5861 5.39236 15.2222H4.22222C2.99479 15.2222 2 14.2274 2 13V9.66667C2 8.43924 2.99479 7.44444 4.22222 7.44444H10.8889C10.9259 7.44444 10.963 7.4442 11 7.4437V15.223Z",
    fill: "#E4E7EC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBullhornSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bullhorn_solid.3a0f3a4a.svg";
export { ForwardRef as ReactComponent };